
import { VERSION, ENVIRONMENT } from '@/constants'

declare let pulse

export interface PulseEvent {
  name: string | null;
  type: 'Accept'|
  'Activate'|
  'Apply'|
  'Attempt'|
  'Autobump'|
  'Block'|
  'Bump'|
  'Call'|
  'Click'|
  'Close'|
  'Confirm'|
  'Contact'|
  'Create'|
  'Delete'|
  'Dismiss'|
  'Download'|
  'Edit'|
  'Engagement'|
  'Error'|
  'Filter'|
  'Follow'|
  'Hide'|
  'Inpersonmeeting'|
  'Install'|
  'Launch'|
  'Like'|
  'Login'|
  'Logout'|
  'Load'|
  'Minimize'|
  'Notification'|
  'Open'|
  'Pause'|
  'Play'|
  'Purchase'|
  'Rate'|
  'Recommend'|
  'Refer'|
  'Reject'|
  'Request'|
  'Renew'|
  'Report'|
  'Save'|
  'Search'|
  'Send'|
  'Share'|
  'Show'|
  'Smartbump'|
  'SMS'|
  'Sort'|
  'Stop'|
  'Transactioncomplete'|
  'Unblock'|
  'Unfollow'|
  'Uninstall'|
  'Unlike'|
  'Unsave'|
  'Update'|
  'View'|
  'Watch';
  action?: string;
  object?: Record<string, string>;
  published?: Date;
}
declare global {
  interface Window { pulse: Function }
}

const DEFAULT_EVENT_INTERVAL = 5000
const SCHEMA_TYPE = 'https://schema.adevinta.com/events/tracker-event.json/318.json'
const env = ENVIRONMENT.toLocaleLowerCase()

class PulseTracker {
  startTrackerWithId (id: string): void {
    pulse('init', id, {
      eventDebounce: DEFAULT_EVENT_INTERVAL,
    },
    {
      deployStage: env === 'prod' ? 'pro' : env,
      deployTag: VERSION,
      schema: SCHEMA_TYPE,
    },
    )
  }

  trackEvent (event: PulseEvent, eventType: string): void {
    if (!window.pulse) {
      return
    }
    pulse('track', eventType, event)
    if (ENVIRONMENT !== 'PROD') {
      console.info('>> PULSE EVENT >> ', { event })
    }
  }
}

export const pulseTracker = new PulseTracker()
